"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var SweetAlertStyles_1 = require("../styles/SweetAlertStyles");
var Overlay = /** @class */function (_super) {
  __extends(Overlay, _super);
  function Overlay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.overlayElement = null;
    _this.setOverlayElementRef = function (element) {
      _this.overlayElement = element;
    };
    return _this;
  }
  Overlay.prototype.componentDidMount = function () {
    if (this.overlayElement) {
      this.overlayElement.scrollTop = 0;
    }
  };
  Overlay.prototype.render = function () {
    var _a = this.props,
      show = _a.show,
      _onClick = _a.onClick,
      _onKeyDown = _a.onKeyDown,
      children = _a.children;
    return show ? react_1.default.createElement("div", {
      ref: this.setOverlayElementRef,
      style: __assign(__assign({}, SweetAlertStyles_1.overlay), SweetAlertStyles_1.sweetAlertContainer),
      onClick: function onClick(e) {
        return _onClick(e);
      },
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e);
      }
    }, children) : react_1.default.createElement("div", {
      style: SweetAlertStyles_1.sweetAlertContainer,
      tabIndex: 0,
      onKeyDown: function onKeyDown(e) {
        return _onKeyDown(e);
      }
    }, children);
  };
  return Overlay;
}(react_1.default.Component);
exports.default = Overlay;